var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDragndropIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.59375 2.8125c0-1.55090334-1.2615967-2.8125-2.8125-2.8125h-10.96875c-1.55090334 0-2.8125 1.26159666-2.8125 2.8125v10.96875c0 1.5509033 1.26159666 2.8125 2.8125 2.8125h4.5v1.875h1.875v-1.875h4.59375c1.5509033 0 2.8125-1.2615967 2.8125-2.8125v-4.5h1.828125v-1.875h-1.828125zm-1.875 10.96875c0 .5169067-.4205933.9375-.9375.9375h-10.96875c-.51690675 0-.9375-.4205933-.9375-.9375v-10.96875c0-.51690675.42059325-.9375.9375-.9375h10.96875c.5169067 0 .9375.42059325.9375.9375zm7.40625 6.46875h1.875v1.875c0 1.0354614-.8395386 1.875-1.875 1.875h-1.828125v-1.875h1.828125zm-9.328125 1.875h1.875v1.875h-1.875zm3.75 0h1.875v1.875h-1.875zm7.453125-12.84375v1.875h-1.875v-1.875h-1.828125v-1.875h1.828125c1.0354614 0 1.875.83953856 1.875 1.875zm-1.875 3.65625h1.875v1.875h-1.875zm0 3.65625h1.875v1.875h-1.875zm-12.9375 5.53125h1.828125v1.875h-1.828125c-1.03546144 0-1.875-.8395386-1.875-1.875v-1.875h1.875zm1.734375-14.90625h1.875v5.625h-5.625v-1.875h2.42413331l-3.3449707-3.3449707 1.32586669-1.3256836 3.3449707 3.34478761z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragndropIcon);
export default __webpack_public_path__ + "static/media/dragndrop-icon.80f681d5c20372ccf9f0780b5a33b3c2.svg";
export { ForwardRef as ReactComponent };